export default "__VITE_ASSET__BK3$m$Y6__"